import React from "react";
import { NODES, ROUTES } from "../data/network.js";

// Signature element: animated UK & Ireland network shown in the hero.
const NetworkPanel = () => (
  <div className="net" aria-label="A4 Express delivery network across the United Kingdom and Ireland">
    <div className="net-head">
      <span className="net-title">Network coverage</span>
      <span className="net-live"><i className="dot-live" /> UK &amp; Ireland</span>
    </div>
    <svg viewBox="0 0 240 330" width="100%" style={{ display: "block" }} role="img"
         aria-label="Abstract map of connected delivery hubs across the UK and Ireland">
      {ROUTES.map((d, i) => <path key={"r" + i} d={d} className="route" />)}
      {ROUTES.map((d, i) => (
        <path key={"c" + i} d={d} className="comet" style={{ animationDelay: `${(i * 0.62).toFixed(2)}s` }} />
      ))}
      {NODES.map((p) => (
        <g key={p.n} className={"node" + (p.hub ? " hub" : "")}>
          {p.hub && <circle cx={p.x} cy={p.y} r="5" className="halo" />}
          <circle cx={p.x} cy={p.y} r={p.hub ? 5 : 3.4} />
          <text x={p.x + 10} y={p.y + 3.2}>{p.n}</text>
        </g>
      ))}
    </svg>
    <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10, gap: 12, flexWrap: "wrap" }}>
      <span className="net-title">Mainland · Northern Ireland · Republic of Ireland</span>
      <span className="net-title">Same-day · Next-day · Dedicated</span>
    </div>
  </div>
);

export default NetworkPanel;
